module.exports = __webpack_public_path__ + "img/b1792bf.jpg";